/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchChapters, fetchChapter, updateChapter } from './action';

export const chapterSlice = createSlice({
  name: 'chapter',
  initialState: {
    chapters: [],
    chapter: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setChapter: (state, action) => {
      state.chapter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChapters.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchChapters.fulfilled, (state, action) => {
        state.chapters = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchChapters.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchChapter.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchChapter.fulfilled, (state, action) => {
        state.chapter = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchChapter.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateChapter.fulfilled, (state, action) => {
        state.chapter = action.payload;
      });
  },
});

export const { setChapter } = chapterSlice.actions;

export default chapterSlice.reducer;
